module.exports = "/images/_/_/_/_/Connect/resources/js/src/assets/images/logo/spliced-icon.png";